module.exports = __webpack_public_path__ + "media/images/rollos-0295202d898e967c2ce3ca18847d868b.jpg";